import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm'; // [추가] GFM 플러그인 임포트
import './PolicyPage.css'; // 개인정보처리방침과 동일한 스타일 사용

function TermsPage() {
    const [termsContent, setTermsContent] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // public 폴더의 마크다운 파일을 불러옵니다.
        fetch('/policies/terms.md')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.text();
            })
            .then(text => {
                setTermsContent(text);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching terms:', error);
                setTermsContent('이용약관을 불러오는 데 실패했습니다.');
                setLoading(false);
            });
    }, []);

    return (
        <div className="policy-container">
            {loading ? <p>로딩 중...</p> : <ReactMarkdown remarkPlugins={[remarkGfm]}>{termsContent}</ReactMarkdown>}
        </div>
    );
}

export default TermsPage;